import actionTypes from '../actions/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_INSTANT_GAMES_TRANSITIONS_HISTORY_SUCCESS:
      return [...action.history];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/reducers/instant-games-transitions-history.js